import React, { useEffect, useState } from "react";
import axios from "axios";
import WorkOrder from "../../workOrder";
import OrderSummeryInfo from "../OrderSummeryInfo";
import DetailsWorkOrder from "./detailsWorkOrder";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import "../index.css";
import { BsPencil, BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import moment from "moment";
import { loaderReducer } from "../../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import ContactsSummery from "../ContactsSummery";
import { endPoints } from "../../../utils/endPoints";
import { AiOutlineSync } from "react-icons/ai";
import { use } from "react";
import { useCan } from "../../../utils/permissions";

const Index = ({ tranId, fetchWorkOrders, isRefresh, handleDateSortClick }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isVisible1, setIsVisible1] = useState(true);
  const [isVisible2, setIsVisible2] = useState(true);
  const [activeEdit, setActiveEdit] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [singleWorkOrder, setSingleWorkOrder] = useState(null);
  const [initialWorkOrder, setInitialWorkOrder] = useState(null);
  const [apptDate, setapptDate] = useState(null);
  const [apptTime, setapptTime] = useState(null);
  const [initialApptDate, setInitialApptDate] = useState(null);
  const [initialApptTime, setInitialApptTime] = useState(null);
  const [validationMessage, setValidationMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  // make state for numbers of device and survey
  const [numberOfDevice, setNumberOfDevice] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [contacts, setContacts] = useState([]);
  const can = useCan();
  const cansync = can("sync", "read");
  const caneditworkOrders = can("workOrders", "update");
  const canCreateworkOrders = can("workOrders", "create");
  const canReadworkOrders = can("workOrders", "read");
  const updateValidationMessage = (message) => {
    setValidationMessage(message);
  };

  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();
  // console.log("location in workorder/info---->", tranId);

  useEffect(() => {
    const fetchSingleWorkOrder = async () => {
      // debugger
      dispatch(loaderReducer(true));
      if (tranId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API}/workOrders/tranId/${tranId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          dispatch(loaderReducer(false));
          const data = await response.json();
          console.log("single work order data----->", data);

          setSingleWorkOrder(data.workOrder);
          setInitialWorkOrder(data.workOrder);
          setNumberOfDevice(data.workOrder.device);
          setContacts(data.workOrder.customers);

          // const apptDateObj = new Date(data.workOrder.apptDate);
          // const apptDateFormatted = apptDateObj.toLocaleDateString("en-US", {
          //   month: "2-digit",
          //   day: "2-digit",
          //   year: "numeric",
          // });

          // let apptTimeFormatted;
          // if (data.workOrder.apptDate.startsWith("0000-00-00T")) {
          //   const timePart = data.workOrder.apptDate.split("T")[1];
          //   const timeObj = new Date(`1970-01-01T${timePart}`);
          //   apptTimeFormatted = timeObj.toLocaleTimeString("en-US", {
          //     hour: "2-digit",
          //     minute: "2-digit",
          //   });
          // } else {
          //   apptTimeFormatted = apptDateObj.toLocaleTimeString("en-US", {
          //     hour: "2-digit",
          //     minute: "2-digit",
          //   });
          // }
          if (data.workOrder.apptDate) {
            const apptDateTime = moment(
              data.workOrder.apptDate,
              "MM/DD/YYYY hh:mm:ss a"
            );
            const apptDateFormatted = apptDateTime.format("MM/DD/YYYY"); // For display as date
            const apptTimeFormatted = apptDateTime.format("hh:mm a");

            setapptDate(apptDateFormatted);
            setapptTime(apptTimeFormatted);

            // console.log("apptDateFormattted--------------->", apptDateFormatted);
            // console.log("apptTimeFormatted--------------->", apptTimeFormatted);

            // Store the original apptDate and apptTime
            setInitialApptDate(apptDateFormatted);
            setInitialApptTime(apptTimeFormatted);
          } else {
            setapptDate("");
            setapptTime("");
            setInitialApptDate("");
            setInitialApptTime("");
          }

          // console.log("data----->", data);
        } catch (error) {
          dispatch(loaderReducer(false));
          console.error("Error fetching single work order:", error);
        }
      }
    };

    fetchSingleWorkOrder();
  }, [tranId, isRefresh]);

  // useEffect(() => {
  //   fetchDataFromSkyKit();
  // }, [tranId]);

  // fetch Survey data here
  useEffect(() => {
    const fetchSurveys = async () => {
      if (tranId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API}/task/survey-by-order-id-admin/${tranId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = await response.json();
          console.log("surveys----->", data.data);
          if (
            data.data.taskCompleted.length > 0 ||
            data.data.taskInCompleted.length > 0
          ) {
            const combinedTasks = [
              ...data.data.taskCompleted,
              ...data.data.taskInCompleted,
            ];
            setSurveys(combinedTasks);
          } else {
            setSurveys([]);
          }
        } catch (error) {
          console.error("Error fetching surveys:", error);
          setSurveys([]);
        }
      }
    };
    fetchSurveys();
  }, [tranId, isRefresh]);

  const handleClick = () => {
    setIsVisible(!isVisible);
  };
  const handleClick2 = () => {
    setIsVisible1(!isVisible1);
  };
  const handleClick3 = () => {
    setIsVisible2(!isVisible2);
  };
  // const handleClickTech = () => {
  //   setIsVisibleTech(!isVisibleTech);
  // };
  const handleActiveEdit = () => {
    if (!caneditworkOrders) return;
    setActiveEdit(!activeEdit);
  };

  const handleExitWithoutSaving = () => {
    setActiveEdit(false);
    setSingleWorkOrder(initialWorkOrder);
    setapptDate(initialApptDate);
    setapptTime(initialApptTime);
  };
  const handleSync = () => {
    // Dispatch loaderReducer to true before starting the API call
    dispatch(loaderReducer(true));
    console.log("singleWorkOrder in sync api", singleWorkOrder);

    // Call the sync API
    axios
      .get(
        `${process.env.REACT_APP_API}/sync/individual-sync/${singleWorkOrder.orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        // Dispatch loaderReducer to false after the API call is successful
        dispatch(loaderReducer(false));
        // dispatch(syncReducer("syncingComplete"));
        // Show success toast
        toast.success("Sync completed successfully");
        // console.log("Sync successful", response);
      })
      .catch((error) => {
        // Dispatch loaderReducer to false if an error occurs
        dispatch(loaderReducer(false));
        // Show error toast
        toast.error("An error occurred during sync");
        console.error("Sync error", error);
      });
  };

  // console.log("....singleWorkOrder", singleWorkOrder?.device);

  const handleSaveChanges = async () => {
    if (activeEdit && caneditworkOrders) {
      try {
        setDisabled(true);
        const timeMoment = moment(apptTime, "HH:mm:a");

        let dateMoment;
        // let combinedDateTime;
        // if (apptDate !== null) {
        dateMoment = moment(apptDate);
        dateMoment.hours(timeMoment.hours()).minutes(timeMoment.minutes());
        const combinedDateTime = `${apptDate} ${apptTime}`;

        // combinedDateTime = dateMoment.format("YYYY-MM-DDTHH:mm:ss");
        // } else {
        // dateMoment = moment("1970-01-01T00:00:00.000Z")
        // combinedDateTime = "0000-00-00T00:00:00.000Z"
        // combinedDateTime = `0000-00-00T${timeMoment.format("HH:mm:ss")}`;
        // }

        // const combinedDateTime = dateMoment.toISOString();

        // console.log(apptDate, "<- date and time ->", apptTime);
        // console.log("combinedDateTime---------->", combinedDateTime);
        dispatch(loaderReducer(true));
        const response = await fetch(
          `${process.env.REACT_APP_API}/workOrders/update`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              tranId: singleWorkOrder.tranId,
              specialInstructions: singleWorkOrder.specialInstructions,
              jobType: singleWorkOrder.jobType,
              apptDate: singleWorkOrder.apptDate,
              address: singleWorkOrder.address,
              phone: singleWorkOrder.phone,
              apptDate: combinedDateTime,
              apptStatus: singleWorkOrder.apptStatus,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to update work order");
        }

        const result = await response.json();
        // console.log("Work order updated!", result);
        dispatch(loaderReducer(false));
        fetchWorkOrders();
        setDisabled(false);
        setActiveEdit(false);
        toast.success("details updated successfully");
      } catch (error) {
        console.error("Error updating work order:", error);
        dispatch(loaderReducer(false));
        toast.error("some error occured, try again later");
        setDisabled(false);
      }
    }
  };
  const [lastPingTime, setLastPingTime] = useState(null);

  const fetchDataFromSkyKit = async () => {
    if (!canReadworkOrders) return;
    dispatch(loaderReducer(true));
    if (tranId) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}/workOrders/${endPoints.GET_DATA_FROM_SKY_KIT}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ tranId: tranId }),
          }
        );
        dispatch(loaderReducer(false));

        const data = await response.json();
        // console.log(object);
        // Merge the existing object with the new device data
        setSingleWorkOrder((prevState) => ({
          ...prevState,
          device: data.data, // Update only the device field
        }));
        setLastPingTime(new Date()); // update ping time
      } catch (error) {
        dispatch(loaderReducer(false));
        console.error("Error fetching single work order:", error);
      }
    }
  };
  const handleSyncInDevice = async (e) => {
    if (!caneditworkOrders) return;
    // e.stopPropagation();
    await fetchDataFromSkyKit();
  };

  // filter a single work order category wise

  const [singleWorkOrderCategory, setSingleWorkOrderCategory] = useState(
    singleWorkOrder?.device || singleWorkOrder
  );

  useEffect(() => {
    if (singleWorkOrder?.device) {
      setSingleWorkOrderCategory(singleWorkOrder?.device);
      // handleSort();
    }
  }, [singleWorkOrder?.device]);

  const handleFilterWorkOrder = (e) => {
    const filterValue = e.target.value;
    if (filterValue === "All") {
      setSingleWorkOrderCategory(singleWorkOrder?.device);
    } else if (filterValue === "In Transit") {
      const filteredDevices = singleWorkOrder?.device?.filter(
        (device) => device?.custrecord_bg_asset_status === "In Transit"
      );
      setSingleWorkOrderCategory(filteredDevices);
    } else if (filterValue === "Active") {
      const filteredDevices = singleWorkOrder?.device?.filter(
        (device) => device?.custrecord_bg_asset_status === "Active"
      );
      setSingleWorkOrderCategory(filteredDevices);
    }
  };

  // highligted
  const [highlightedSerial, setHighlightedSerial] = useState(null);
  const [highlightedSerial1, setHighlightedSerial1] = useState(null);

  const [sortedAsc, setSortedAsc] = useState(true);

  // const handleSort = () => {
  //   const sortedDevices = [...singleWorkOrderCategory].sort((a, b) => {
  //     const dateA = new Date(a.heartbeatUpdated);
  //     const dateB = new Date(b.heartbeatUpdated);

  //     // Ascending sort: older first
  //     if (sortedAsc) {
  //       return dateA - dateB;
  //     } else {
  //       return dateB - dateA;
  //     }
  //   });

  //   setSingleWorkOrderCategory(sortedDevices);
  //   setSortedAsc(!sortedAsc); // toggle sort order
  // };

  // console.log("Before sort", singleWorkOrderCategory.map(d => d.heartbeatUpdated));



  const handleSort = () => {
    const getPriority = (device) => {
      const status = device.custrecord_bg_asset_status;
      const isOnline = device.online;
      const hasHeartbeat = !!device.heartbeatUpdated;

      // Priority based on business rules
      if (status === "Active" && isOnline && hasHeartbeat) return 1;
      if (status === "Active" && !isOnline && hasHeartbeat) return 1;
      if (status === "In Transit" && hasHeartbeat) return 1;
      if (hasHeartbeat) return 4;
      return 5; // No heartbeat, last
    };

    const sortedDevices = [...singleWorkOrderCategory].sort((a, b) => {
      const priorityA = getPriority(a);
      const priorityB = getPriority(b);

      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      // If same priority and heartbeat exists, sort by heartbeatUpdated
      if (a.heartbeatUpdated && b.heartbeatUpdated) {
        const dateA = new Date(a.heartbeatUpdated);
        const dateB = new Date(b.heartbeatUpdated);
        return sortedAsc ? dateA - dateB : dateB - dateA;
      }

      return 0;
    });

    setSingleWorkOrderCategory(sortedDevices);
    const nextOrder = sortedAsc ? "desc" : "asc";
    localStorage.setItem("deviceSortOrder", nextOrder);
    setSortedAsc(!sortedAsc);
  };
  const scrollToDevice = (serial) => {
    const el = document.getElementById(`device-${serial}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      setHighlightedSerial(serial);
      // setTimeout(() => {
      //   setHighlightedSerial(null);
      // }, 5000);
    }
  };

  const scrollToDevice1 = (serial) => {
    const el = document.getElementById(`survey-${serial}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      setHighlightedSerial1(serial);
      setTimeout(() => {
        setHighlightedSerial1(null);
      }, 5000);
    }
  };

  const formatTime = (date) => {
    if (!date) return "—";
    const dt = new Date(date);
    return dt.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  //   useEffect(() => {
  //   console.log("📌 useEffect mounted");
  //   const interval = setInterval(() => {
  //     console.log("⏰ Interval Running...");
  //     handleSyncInDevice();
  //   }, 30000);
  //   return () => {
  //     clearInterval(interval);
  //     console.log("🧹 Interval cleared");
  //   };
  // }, []);
  useEffect(() => {
    if (!tranId || !token) return;

    console.log(" useEffect mounted with valid tranId and token");

    fetchDataFromSkyKit(); // initial fetch

    const interval = setInterval(() => {
      console.log(" Interval Running...");
      handleSyncInDevice();
    }, 4 * 60 * 1000);

    return () => {
      clearInterval(interval);
      console.log(" Interval cleared");
    };
  }, [tranId, token]);

  return (
    // <WorkOrder>
    <div>
      {singleWorkOrder && (
        <>
          {/* {caneditworkOrders && */}
          {/*   <div */}
          {/*     className="iconflex" */}
          {/*     onClick={() => { */}
          {/*       if (!cansync) return; */}
          {/*       handleSync(); */}
          {/*     }} */}
          {/*     style={{ */}
          {/*       color: cansync ? "#000" : "#aaa", */}
          {/*       opacity: cansync ? 1 : 0.5, */}
          {/*       cursor: cansync ? "pointer" : "not-allowed", */}
          {/*     }} */}
          {/*   > */}
          {/*     <div className="fonticon"> */}
          {/*       <AiOutlineSync /> */}
          {/*     </div> */}
          {/*     Sync */}
          {/*   </div> */}
          {/* } */}

          {!activeEdit && (
            <div className="editbtn" onClick={handleActiveEdit} style={{
              color: caneditworkOrders ? "#000" : "#aaa",
              opacity: caneditworkOrders ? 1 : 0.5,
              cursor: caneditworkOrders ? "pointer" : "not-allowed",
            }}>
              Edit Info
            </div>
          )}
          <div className="PSbtn mt-3">
            <div
              className="priorbtn"
              style={{
                backgroundColor:
                  singleWorkOrder?.priority === "Low"
                    ? "#C2CDDD"
                    : singleWorkOrder?.priority === "High"
                      ? "#F47E75"
                      : singleWorkOrder?.priority === "Medium"
                        ? "#4585B2"
                        : singleWorkOrder?.priority === "Urgent"
                          ? "#FF3535"
                          : "#414C60",
                color: "#FFF",
              }}
            >
              PRIORITY: {singleWorkOrder?.priority}
            </div>
            <div
              className="priorbtn"
              style={{
                backgroundColor:
                  singleWorkOrder?.apptStatus === "onhold"
                    ? "#FFB23E"
                    : singleWorkOrder?.apptStatus === "rejected"
                      ? "#FF3535"
                      : singleWorkOrder?.apptStatus === "scheduled"
                        ? "#4585B2"
                        : singleWorkOrder?.apptStatus === "completed"
                          ? "#84d504"
                          : singleWorkOrder?.apptStatus === "pending"
                            ? "#C2CDDD"
                            : singleWorkOrder?.apptStatus === "rescheduled"
                              ? "#4585B2"
                              : singleWorkOrder?.apptStatus === "cancelled"
                                ? "#7a1717"
                                : singleWorkOrder?.apptStatus === "Partially Completed"
                                  ? "#7a5862"
                                  : singleWorkOrder?.apptStatus === "Order Fix Needed"
                                    ? "#FF3555"
                                    : "#414C60",
                color: "#FFF",
              }}
            >
              APPOINTMENT STATUS: {singleWorkOrder?.apptStatus}
            </div>
            <div
              className="priorbtn"
              style={{
                backgroundColor:
                  singleWorkOrder?.reconciliationStatus === "Completed"
                    ? "#84D504"
                    : singleWorkOrder?.reconciliationStatus ===
                      "Order Fix Needed"
                      ? "#F47E75"
                      : singleWorkOrder?.reconciliationStatus === "In Progress"
                        ? "#4585B2"
                        : singleWorkOrder?.reconciliationStatus === "Not Started"
                          ? "#FFB23E"
                          : singleWorkOrder?.reconciliationStatus === "Reviewed"
                            ? "#15e64c"
                            : "#414C60",
                color: "#FFF",
              }}
            >
              RECONCILIATION STATUS: {singleWorkOrder?.reconciliationStatus}
            </div>
          </div>
          <div className="tupdate mt-4">Status Updates</div>
          <div className="mt-2 textcont">
            <div>
              {" "}
              {new Date(singleWorkOrder?.createdAt).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }
              )}
            </div>
            <div>Order added in Netsuite</div>
          </div>

          <div>
            <p>
              <label for="instructions" className="tupdate mt-4">
                Special Instructions
              </label>
            </p>
            <textarea
              className="form-control mt-2"
              id="instructions"
              name="instructions"
              placeholder="Instructions"
              value={singleWorkOrder?.specialInstructions}
            ></textarea>
          </div>
          {/* Details */}
          <div className="tupdate mt-4">Details</div>
          <DetailsWorkOrder
            arg={{
              activeEdit,
              singleWorkOrder,
              setSingleWorkOrder,
              apptDate,
              apptTime,
              setapptDate,
              setapptTime,
              updateValidationMessage,
              validationMessage,
              numberOfDevice,
              tranId,
              surveys,
            }}
          />

          {/* Order Summary */}
          {!activeEdit && (
            <div>
              <div className="tupdate mt-4">Survey Summary</div>
              <div
                className="inspcls textcont mt-2 d-flex justify-content-between"
                onClick={handleClick}
                style={{
                  borderRadius: isVisible ? "" : "8px",
                  border: isVisible ? "" : "1px solid var(--grey2, #c2cddd)",
                }}
              >
                <div className="d-flex justify-content-between">Surveys</div>
                <div>
                  <span style={{ marginRight: "10px" }}>
                    Count: {surveys.length}
                  </span>{" "}
                  {isVisible ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              {isVisible && (
                <OrderSummeryInfo
                  tranId={tranId}
                  surveys={surveys}
                  singleWorkOrder={singleWorkOrder}
                  onDeviceClick={scrollToDevice}
                  // singleWorkOrderCategory={singleWorkOrderCategory}
                  highlightedSerial={highlightedSerial}
                  // from Survey → Device
                  onDeviceClick1={scrollToDevice1}
                  highlightedSerial1={highlightedSerial1}
                />
              )}
            </div>
          )}
          {/* All Equipment on Site */}
          {!activeEdit && (
            <div>
              <div
                className="inspcls textcont mt-2 d-flex justify-content-between"
                style={{
                  borderRadius: isVisible1 ? "" : "8px",
                  border: isVisible1 ? "" : "1px solid var(--grey2, #c2cddd)",
                }}
              >
                <div>Devices at Customer </div>
                <div className="d-flex justify-content-between align-items-center gap-1">

                  <div>
                    <select
                      class="form-select "
                      aria-label="Default select example"
                      onChange={handleFilterWorkOrder}
                    >
                      {/* <option selected>Select a Filter</option> */}
                      <option value="All" selected>
                        All
                      </option>
                      <option value="In Transit">In Transit</option>
                      <option value="Active">Active</option>
                    </select>
                  </div>
                  <div>{/* <p className="m-0"></p> */}</div>
                  <div
                    className="iconflex"
                    onClick={(e) => {
                      handleSyncInDevice(e);
                    }}
                    style={{
                      color: canCreateworkOrders ? "#000" : "#aaa",
                      opacity: canCreateworkOrders ? 1 : 0.5,
                      cursor: canCreateworkOrders ? "pointer" : "not-allowed",
                    }}
                  >
                    <div className="fonticon">
                      {/* <AiOutlineSync /> */}
                      <svg
                        width="29"
                        height="20"
                        viewBox="0 0 29 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 13.5714C0 17.1205 2.92266 20 6.525 20H23.2C26.4036 20 29 17.442 29 14.2857C29 11.5223 27.0063 9.21429 24.36 8.6875C24.5458 8.20982 24.65 7.6875 24.65 7.14286C24.65 4.77679 22.7016 2.85714 20.3 2.85714C19.4073 2.85714 18.5736 3.125 17.8848 3.58036C16.6297 1.4375 14.287 0 11.6 0C7.59438 0 4.35 3.19643 4.35 7.14286C4.35 7.26339 4.35453 7.38393 4.35906 7.50446C1.82156 8.38393 0 10.7679 0 13.5714Z"
                          fill="#2E58FE"
                        />
                        <path
                          d="M18.9751 9.25454C19.0347 9.4245 18.9844 9.61399 18.8557 9.7351L18.0482 10.5048C18.0687 10.6669 18.0799 10.833 18.0799 11.001C18.0799 11.169 18.0687 11.335 18.0482 11.4972L18.8557 12.2668C18.9844 12.388 19.0347 12.5775 18.9751 12.7474C18.893 12.9799 18.7941 13.2026 18.6804 13.4175L18.5927 13.5757C18.4696 13.7906 18.3316 13.9937 18.1806 14.1852C18.0705 14.3258 17.8878 14.3727 17.7236 14.318L16.6848 13.9723C16.4349 14.1735 16.1589 14.3415 15.8642 14.4685L15.6311 15.5839C15.5938 15.7617 15.4633 15.9023 15.2917 15.9316C15.0343 15.9766 14.7695 16 14.4991 16C14.2286 16 13.9638 15.9766 13.7064 15.9316C13.5349 15.9023 13.4043 15.7617 13.367 15.5839L13.1339 14.4685C12.8392 14.3415 12.5632 14.1735 12.3133 13.9723L11.2764 14.32C11.1122 14.3747 10.9295 14.3258 10.8194 14.1871C10.6684 13.9957 10.5304 13.7925 10.4073 13.5777L10.3196 13.4194C10.2059 13.2045 10.107 12.9818 10.0249 12.7494C9.96527 12.5794 10.0156 12.3899 10.1443 12.2688L10.9519 11.4991C10.9313 11.335 10.9201 11.169 10.9201 11.001C10.9201 10.833 10.9313 10.6669 10.9519 10.5048L10.1443 9.7351C10.0156 9.61399 9.96527 9.4245 10.0249 9.25454C10.107 9.02207 10.2059 8.79938 10.3196 8.58449L10.4073 8.42626C10.5304 8.21137 10.6684 8.0082 10.8194 7.81676C10.9295 7.67611 11.1122 7.62922 11.2764 7.68392L12.3152 8.02969C12.5651 7.82848 12.8411 7.66048 13.1358 7.5335L13.3689 6.41805C13.4062 6.24028 13.5367 6.09963 13.7083 6.07033C13.9657 6.02344 14.2305 6 14.5009 6C14.7714 6 15.0362 6.02344 15.2936 6.06837C15.4651 6.09768 15.5957 6.23833 15.633 6.4161L15.8661 7.53155C16.1608 7.65853 16.4368 7.82653 16.6867 8.02774L17.7255 7.68197C17.8896 7.62727 18.0724 7.67611 18.1824 7.81481C18.3335 8.00625 18.4715 8.20942 18.5946 8.4243L18.6822 8.58254C18.796 8.79742 18.8949 9.02012 18.9769 9.25259L18.9751 9.25454ZM14.5009 12.5638C14.8966 12.5638 15.2761 12.3991 15.5559 12.106C15.8357 11.813 15.9929 11.4155 15.9929 11.001C15.9929 10.5865 15.8357 10.189 15.5559 9.89591C15.2761 9.60282 14.8966 9.43817 14.5009 9.43817C14.1052 9.43817 13.7257 9.60282 13.4459 9.89591C13.1661 10.189 13.0089 10.5865 13.0089 11.001C13.0089 11.4155 13.1661 11.813 13.4459 12.106C13.7257 12.3991 14.1052 12.5638 14.5009 12.5638Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        flexDirection: "column",
                        cursor: canCreateworkOrders ? "pointer" : "not-allowed",
                      }}
                    >
                      <p style={{ margin: 0 }}>Last Sync to SK</p>
                      <p style={{ margin: 0, color: "green" }}>
                        {" "}
                        {lastPingTime ? formatTime(lastPingTime) : "—"}
                      </p>
                    </div>
                  </div>

                  <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                    Count: {numberOfDevice.length}
                  </span>
                  <div>
                    {sortedAsc ? (
                      <BsSortAlphaDown onClick={handleSort} />
                    ) : (
                      <BsSortAlphaDownAlt onClick={handleSort} />
                    )}
                  </div>
                  <div onClick={handleClick2} style={{ marginRight: "10px", marginLeft: "10px" }}>
                    {isVisible1 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                  </div>
                </div>
              </div>
              {isVisible1 && (
                <OrderSummeryInfo
                  singleWorkOrder={singleWorkOrder}
                  onDeviceClick={scrollToDevice}
                  // singleWorkOrderCategory={singleWorkOrderCategory}
                  highlightedSerial={highlightedSerial}
                  singleWorkOrderCategory={singleWorkOrderCategory}
                  onDeviceClick1={scrollToDevice1}
                  highlightedSerial1={highlightedSerial1}
                  handleSort={handleSort}
                  sortedAsc={sortedAsc}
                  setSortedAsc={setSortedAsc}
                />
              )}
            </div>
          )}

          {!activeEdit && (
            <div>
              <div
                className="inspcls textcont mt-2 d-flex justify-content-between"
                onClick={handleClick3}
                style={{
                  borderRadius: isVisible2 ? "" : "8px",
                  border: isVisible2 ? "" : "1px solid var(--grey2, #c2cddd)",
                }}
              >
                <div>Contacts</div>
                <div>
                  <span style={{ marginRight: "10px" }}>
                    Count: {contacts.length}
                  </span>
                  {isVisible2 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              {isVisible2 && <ContactsSummery contacts={contacts} />}
            </div>
          )}

          {activeEdit && (
            <div className="d-flex mt-4 gap-2 justify-content-end">
              <div className="contd" onClick={handleExitWithoutSaving}>
                Exit without Saving
              </div>{" "}
              <button
                className="contd"
                style={{
                  backgroundColor: "#1C449C",
                  color: "white",
                  opacity: validationMessage === "" && !disabled ? 1 : 0.5,
                }}
                onClick={handleSaveChanges}
                disabled={validationMessage !== "" || disabled}
              >
                Save Changes
              </button>
            </div>
          )}
        </>
      )}
    </div>
    // </WorkOrder>
  );
};

export default Index;
